import React from "react";
import {
  User,
  Users,
  BookOpen,
  ClipboardList,
  MessageCircle,
  LayoutDashboard,
  Calendar,
  Notebook,
  FileSpreadsheet
} from "lucide-react";

function Sidebar({ activeSection, onNavClick, isOpen, badges = {} }) {
  const navItems = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { id: "enrolment-record", label: "New Enrolments", icon: ClipboardList },
    { id: "student-record", label: "Student Record", icon: User },
    { id: "agent-record", label: "Agent Record", icon: Users },
    { id: "course", label: "Course", icon: BookOpen },
    { id: "enquiry", label: "Student Enquiry", icon: MessageCircle },
    { id: "leave", label: "Leave Management", icon: Calendar },
    { id: "invoice-settings", label: "Invoice Settings", icon: Notebook },
    { id: "attendance", label: "Attendance", icon: FileSpreadsheet },
  ];

  return (
    <nav className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img
            className="sidebar-image"
            src={require("../images/logo.png")}
            alt="CIET Logo"
          />
        </div>
        <h2 className="sidebar-title">CIET</h2>
        <p className="sidebar-subtitle">Admin Portal</p>
      </div>

      <div className="nav-section">
        <div className="nav-section-title">Project Roadmap</div>

        {navItems.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`nav-item ${activeSection === id ? "active" : ""}`}
            onClick={() => onNavClick(id)}
          >
            <Icon className="nav-item-icon" />
            {label}
            {badges[id] > 0 && <span className="nav-badge">{badges[id]}</span>}
          </button>
        ))}
      </div>
    </nav>
  );
}

export default Sidebar;
